import { render, staticRenderFns } from "./service-provider.vue?vue&type=template&id=b6e35048"
import script from "./service-provider.vue?vue&type=script&lang=js"
export * from "./service-provider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports